/*
 * The shop's completion deadline, in days. Stamped onto every order at checkout
 * by `domain.influencers.completionDeadlineFor`, which falls back to 7 when the
 * column is null — so an unset shop behaves as 7 and the field shows 7.
 *
 * The column is `tinyint unsigned`, hence the ceiling. The floor is 1 rather
 * than 0 because a zero-day deadline would mark every order overdue the moment
 * it was placed.
 */
export const DEFAULT_DEADLINE_DAYS = 7;
export const MIN_DEADLINE_DAYS = 1;
export const MAX_DEADLINE_DAYS = 255;

export const deadlineDaysOf = (influencer) =>
  influencer?.completionDeadline ?? DEFAULT_DEADLINE_DAYS;

export const parseDeadlineDays = (input) => {
  const trimmed = String(input ?? "").trim();

  if (trimmed === "") {
    return { ok: false, error: "Enter a number of days" };
  }

  const days = Number(trimmed);

  if (!Number.isInteger(days)) {
    return { ok: false, error: "Use a whole number of days" };
  }

  return days < MIN_DEADLINE_DAYS || days > MAX_DEADLINE_DAYS
    ? {
        ok: false,
        error: `Must be between ${MIN_DEADLINE_DAYS} and ${MAX_DEADLINE_DAYS} days`,
      }
    : { ok: true, days };
};

export default {
  DEFAULT_DEADLINE_DAYS,
  MAX_DEADLINE_DAYS,
  MIN_DEADLINE_DAYS,
  deadlineDaysOf,
  parseDeadlineDays,
};
